const i18n = {
  'en-US': {
    'menu.dashboard': 'Dashboard',
    'menu.dashboard.workplace': 'Workplace',
    'menu.user.info': 'User Info',
    'menu.user.setting': 'User Setting',
    'menu.user.switchRoles': 'Switch Roles',
    'menu.user.role.admin': 'Admin',
    'menu.user.role.user': 'General User',
    'navbar.logout': 'Logout',
    'settings.title': 'Settings',
    'settings.themeColor': 'Theme Color',
    'settings.content': 'Content Setting',
    'settings.navbar': 'Navbar',
    'settings.menuWidth': 'Menu Width (px)',
    'settings.navbar.theme.toLight': 'Click to use light mode',
    'settings.navbar.theme.toDark': 'Click to use dark mode',
    'settings.menu': 'Menu',
    'settings.footer': 'Footer',
    'settings.otherSettings': 'Other Settings',
    'settings.colorWeek': 'Color Week',
    'settings.alertContent': 'After the configuration is only temporarily effective, if you want to really affect the project, click the "Copy Settings" button below and replace the configuration in settings.json.',
    'settings.copySettings': 'Copy Settings',
    'settings.copySettings.message': 'Copy succeeded, please paste to file src/settings.json.',
    'settings.close': 'Close',
    'settings.color.tooltip': '10 gradient colors generated according to the theme color',
    'message.tab.title.message': 'Message',
    'message.tab.title.notice': 'Notice',
    'message.tab.title.todo': 'ToDo',
    'message.allRead': 'All Read',
    'message.seeMore': 'SeeMore',
    'message.empty': 'Empty',
    'message.empty.tips': 'No Content',
    'message.lang.tips': 'Language switch to ',
    'navbar.search.placeholder': 'Please search',
    'menu.instance': 'Instance',
    'menu.instance.list': 'My Instances',
    'menu.account': 'Account',
    'menu.account.profile': 'Profile',
    'menu.account.security': 'Security',
    'menu.team': 'Team',
    'menu.team.info': 'Profile',
    'menu.team.member': 'Member',
    'menu.team.projects': 'Projects',
    'menu.team.domain': 'Domain',
    'menu.team.branding': 'Branding',
    'menu.team.subscription': 'Subscription',
    'menu.team.invoices': 'Invoices',
    'menu.team.role': 'Role',
    'menu.team.permission': 'Permission',
    'menu.team.order': 'Upgrade',
    'menu.project': 'Project',
    'menu.project.pops': 'Pops',
    'menu.project.cidr': 'CIDR',
    'menu.project.tenants': 'Tenants',
    'menu.tenant': 'Tenant',
    'menu.tenant.monitoring': 'Monitoring',
    'menu.tenant.network': 'Network',
    'menu.tenant.topology': 'Topology',
    'menu.tenant.events': 'Events',
    'menu.tenant.instances': 'Instances',
    'menu.tenant.settings': 'Settings',
    'menu.tenant.network.sites': 'Sites',
    'menu.tenant.network.rules': 'Network Rules',
    'menu.tenant.network.bandwidth': 'Bandwidth Management',
    'menu.tenant.network.eips': 'IP Allocation',
    'instance.binding': 'Binding Host',
    cancle: 'Cancle',
    'nav.team.title': 'Switch Team',
    'nav.team.add': 'Add Team',
    'nav.team.manage': 'Team Management',
    'nav.account.manage': 'Account Settings',
    'nav.scope.project': 'Project',
    'nav.scope.project.empty': 'No project available',
    'nav.scope.project.enter': 'Enter project',
    'nav.scope.project.switchFailed': 'Switch project failed',
    'nav.scope.tenant': 'Tenant',
    'nav.scope.tenant.empty': 'No tenant available'
  },
  'zh-CN': {
    'menu.dashboard': '仪表盘',
    'menu.dashboard.workplace': '工作台',
    'menu.user.info': '用户信息',
    'menu.user.setting': '用户设置',
    'menu.user.switchRoles': '切换角色',
    'menu.user.role.admin': '管理员',
    'menu.user.role.user': '普通用户',
    'navbar.logout': '退出登录',
    'settings.title': '页面配置',
    'settings.themeColor': '主题色',
    'settings.content': '内容区域',
    'settings.navbar': '导航栏',
    'settings.menuWidth': '菜单宽度 (px)',
    'settings.navbar.theme.toLight': '点击切换为亮色模式',
    'settings.navbar.theme.toDark': '点击切换为暗黑模式',
    'settings.menu': '菜单栏',
    'settings.footer': '底部',
    'settings.otherSettings': '其他设置',
    'settings.colorWeek': '色弱模式',
    'settings.alertContent': '配置之后仅是临时生效，要想真正作用于项目，点击下方的 "复制配置" 按钮，将配置替换到 settings.json 中即可。',
    'settings.copySettings': '复制配置',
    'settings.copySettings.message': '复制成功，请粘贴到 src/settings.json 文件中',
    'settings.close': '关闭',
    'settings.color.tooltip': '根据主题颜色生成的 10 个梯度色（将配置复制到项目中，主题色才能对亮色 / 暗黑模式同时生效）',
    'message.tab.title.message': '消息',
    'message.tab.title.notice': '通知',
    'message.tab.title.todo': '待办',
    'message.allRead': '全部已读',
    'message.seeMore': '查看更多',
    'message.empty': '清空',
    'message.empty.tips': '暂无内容',
    'message.lang.tips': '语言切换至 ',
    'navbar.search.placeholder': '输入内容查询',
    'menu.instance': '主机管理',
    'menu.instance.list': '主机列表',
    'menu.account': '账号管理',
    'menu.account.profile': '基本信息',
    'menu.account.security': '安全设置',
    'menu.team': '团队管理',
    'menu.team.info': '团队信息',
    'menu.team.member': '成员管理',
    'menu.team.projects': '项目列表',
    'menu.team.domain': '自定义域名',
    'menu.team.branding': '域名品牌',
    'menu.team.subscription': '订阅管理',
    'menu.team.invoices': '发票管理',
    'menu.team.role': '角色管理',
    'menu.team.permission': '权限管理',
    'menu.team.order': '升级服务',
    'menu.project': '项目管理',
    'menu.project.pops': 'Pops',
    'menu.project.cidr': 'CIDR',
    'menu.project.tenants': '租户列表',
    'menu.tenant': '租户',
    'menu.tenant.monitoring': '监控',
    'menu.tenant.network': '网络',
    'menu.tenant.topology': '拓扑',
    'menu.tenant.events': '事件',
    'menu.tenant.instances': '主机',
    'menu.tenant.settings': '设置',
    'menu.tenant.network.sites': '站点',
    'menu.tenant.network.rules': '网络规则',
    'menu.tenant.network.bandwidth': '带宽管理',
    'menu.tenant.network.eips': 'IP 分配',
    'instance.binding': '绑定主机',
    cancle: '关闭',
    'nav.team.title': '切换团队',
    'nav.team.add': '添加团队',
    'nav.team.manage': '团队管理',
    'nav.account.manage': '账号设置',
    'nav.scope.project': '项目',
    'nav.scope.project.empty': '暂无可用项目',
    'nav.scope.project.enter': '进入项目',
    'nav.scope.project.switchFailed': '切换项目失败',
    'nav.scope.tenant': '租户',
    'nav.scope.tenant.empty': '暂无可用租户'
  }
};
export default i18n;